import React, {  ReactElement } from 'react'
import styles from './index.module.scss'

interface HeaderProps {
    title: string;
    name: string;
    secondName: string;
    children?: any; //
    suffix?: ReactElement | null;
}
const Header = (props: HeaderProps) => {
    return (
        <div className={styles.epro_hader}>
            <div className={styles.header_title}>{props.title}</div>
            <div className={styles.header_name}>{props.name}</div>
            {
                props.secondName && (
                    <div className={styles.header_second_name}>
                        {props.secondName}
                        {props.suffix}
                    </div>
                )
            }
            {props.children}
        </div>
    )
}

export default Header